import styled from "styled-components";

export const AddressFormContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  width: 100%;
  margin: -4rem 0 0;
  padding: 4rem 0 0;

  .address-wrapper {
    margin: 0 0 1rem;
  }
`;

export const Title = styled.h2`
  font-family: Inter;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.688rem;
  color: ${({ theme }) => theme.checkoutOnePage?.textColor};

  margin: 0 0 1rem;
`;
